/**
 * @file
 * Fulbright video overlays.
 */

(function($) {
  var $video_triggers = $("a.overlay-video-trigger");

  if ($video_triggers.length) {
    $video_triggers.each(function(index, element) {
      $(element).on("click", lity);
    });
  }
})(jQuery);
